import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * **Travelanium**
 *
 * @exports bs_136
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_136
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            var aux = window.location.pathname.match(ctx.urlRe);
            aux = aux && aux.length && aux[1];
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            if (window.location.pathname.match(/^\/arabic($|\/)/)) {
                resolve('ar');
                return;
            }
            aux = window.location.hostname.match(ctx.urlRe);
            aux = aux && aux.length && aux[1];
            if (aux && ctx.langs.test(aux)) {
                resolve(aux);
                return;
            }
            thn.domReady().then(function () {
                var $ = window.jQuery;
                aux = $ && $('[data-reveal-id="language-reveal-modal"] .top-label').text();
                if (aux && ctx.langs.test(aux)) {
                    resolve(aux);
                    return;
                }
                reject('no_language');
            });
        });
    };
    /**
       * @memberOf module:bs_136
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        var $ = window.jQuery;
        var mobile = !!(window.location.pathname.match(new RegExp('/propertyibemobile/')));
        var selector = mobile ? '#progress-reveal-modal' : '#ajax-status-panel, #block-ui';
        var $loader = $(selector);
        if ($loader.length
            && !thn.travelaniumUpdater) {
            thn.travelaniumUpdater = thn.debounce(function thnTravelaniumUpdater() {
                // try to refresh the PW data, then hide only if PW data is not set
                if (!$loader.is(':visible')) {
                    thn.languageCheck().then(function ({ changed }) {
                        if (!changed && ctx.widget.refresh() && !ctx.widget.isSet()) {
                            ctx.widget.hide();
                        }
                    });
                }
            }, 600);
            thn.observeDom($loader.get(0), thn.travelaniumUpdater, {
                childList: false,
                subtree: false,
                characterData: false,
                attributes: true,
                attributeFilter: ['class', 'style'],
            });
            thn.pageUnload(function () {
                thn.stopObserveDom($loader.get(0), thn.travelaniumUpdater);
                delete thn.travelaniumUpdater;
            });
        }
    };
    /**
       * @memberOf module:bs_136
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        // Ej: https://reservation.travelanium.net/propertyibe2/rates;jsessionid=dc7a44e9d3acfe6f371f5583b73e?cid=1
        const url = new URL(ctx.baseUrl);
        const validUrl = url.hostname.match(/reservation/);
        if (!validUrl) {
            ctx.newUrl = '';
            return ctx;
        }
        // Export into ctx.newUrl
        ctx.newUrl = url.toString();
        return ctx;
    };
    /**
       * @memberOf module:bs_136
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData_v1 = function priceParseData_v1(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        const dataLayer = window.dataLayer;
        let noRoomsSelector;
        const mobile = !!(window.location.pathname.match(new RegExp('/propertyibemobile/')));
        var leftMargin;
        if (!thn.data.travelaniumInitialLeftMargin) { // init
            leftMargin = $('.ui-slider-handle.ui-state-default.ui-corner-all:eq(0)').css('left') || '0px';
            thn.data.travelaniumInitialLeftMargin = parseFloat(leftMargin.substr(0, leftMargin.length - 2));
        }
        leftMargin = $('.ui-slider-handle.ui-state-default.ui-corner-all:eq(0)').css('left') || '0px';
        leftMargin = parseFloat(leftMargin.substr(0, leftMargin.length - 2));
        const specificRate = $('input[id^="rateFilter"]:checked, input[id^="roomtypeFilter"]:checked, input[id^="otherFilter"]:checked').length
            || (leftMargin && leftMargin > thn.data.travelaniumInitialLeftMargin);
        widgetData.priceSpecial = specificRate ? 1 : 0;
        let $prices;
        widgetData.language = thn.data.language;
        const checkin = (document.querySelector('#s_checkin')?.value || window.localData?.h_checkin)?.replace(/-/g, '/');
        const checkout = (document.querySelector('#s_checkout')?.value || window.localData?.h_checkout)?.replace(/-/g, '/');
        if (mobile) {
            const datesRaw = $('.room-rate-listing-stay-period').text();
            let dates;
            if (datesRaw && !checkin && !checkout) {
                dates = datesRaw.replace(/[\n\r\s]+/g, ' ').match(new RegExp('(\\d+\\s+[^\\d\\s]+\\s+\\d+)[^\\d]+(\\d+\\s+[^\\d\\s]+\\s+\\d+)'));
                if (dates && dates.length === 3) {
                    widgetData.dateBegin = translateDate(dates[1], thn.data.language);
                    widgetData.dateEnd = translateDate(dates[2], thn.data.language);
                    if (!widgetData.dateBegin || !widgetData.dateEnd) {
                        widgetData.dateBegin = translateDate(dates[1], 'en');
                        widgetData.dateEnd = translateDate(dates[2], 'en');
                    }
                }
            }
            else {
                widgetData.dateBegin = checkin;
                widgetData.dateEnd = checkout;
            }
            const ecommerce = dataLayer && thn.arrayGet(dataLayer, 'ecommerce');
            if (ecommerce && ecommerce.checkout && ecommerce.checkout.products && ecommerce.checkout.products.length) {
                widgetData.adults = parseInt(ecommerce.checkout.products[0].numberAdults, 10) || 2;
                widgetData.children = parseInt(ecommerce.checkout.products[0].numberChildren, 10) || 0;
                widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);
            }
            if (!widgetData.adults || !widgetData.children) {
                const capacityEl = document.querySelector('.room-capacity-panel');
                const adultsEls = capacityEl && capacityEl.querySelectorAll('.icon-room-capacity-adult');
                widgetData.adults = (adultsEls && adultsEls.length) || 2;
                widgetData.children = 0;
                widgetData.guests = widgetData.adults + widgetData.children;
            }
            $prices = $('.rate-of-room, .starting-rate-of-room');
            noRoomsSelector = '.no-result-statement:visible';
        }
        else { // desktop
            const dateBeginRaw = ($('#checkin-calendar').val() || '');
            const dateEndRaw = ($('#checkout-calendar').val() || '');
            if (dateBeginRaw && dateEndRaw && !checkin && !checkout) {
                const dateBegin = dateBeginRaw.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1'); // dd/mm/yyyy
                const dateEnd = dateEndRaw.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1'); // dd/mm/yyyy
                widgetData.dateBegin = dateBegin;
                widgetData.dateEnd = dateEnd;
            }
            else {
                widgetData.dateBegin = checkin;
                widgetData.dateEnd = checkout;
            }
            const rooms = parseInt($('#room-count-select-box').val(), 10) || 1;
            if (rooms > 1) {
                widgetData.guests = widgetData.adults = 2;
            }
            else {
                widgetData.adults = parseInt($('#adult-count-select-box').val(), 10) || 2;
                widgetData.children = parseInt($('#child-count-select-box').val(), 10) || 0;
                widgetData.guests = Math.max(1, widgetData.adults + widgetData.children);
            }
            $prices = $('.final-rate').filter(function (idx, el) {
                return $(el).closest('.rate-excerpt-column').siblings('.column-4').find('.unable-to-book').length === 0;
            });
            noRoomsSelector = '.no-room-found:visible, .no-room-found-panel, #no_result';
        }
        widgetData.rooms = 1;
        const prices = $prices.map(function (idx, el) {
            return thn.parseNumber($(el).text());
        }).toArray();
        if (prices.length) {
            const $sample = mobile ? $('.currency-text:eq(0)') : $prices.eq(0);
            widgetData.price = Math.min(...prices);
            widgetData.currency = thn.getCurrencyCode($sample.text().trim().match(/[^\d\s,.]+/)[0]);
            widgetData.set = true;
        }
        else if ($(noRoomsSelector).length) {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    engine.priceParseData_v2 = function priceParseData_v2(ctx) {
        // Seems that Travelanium has a new version. Sometimes the website load the old version, sometimes the newer one.
        // I have not yet stablished the reason why that happens
        // Dates
        const widgetData = {};
        const $ = window.jQuery;
        const dateBeginText = $('.v-date-checkin').text();
        const dateEndText = $('.v-date-checkout').text();
        const checkin = (document.querySelector('#s_checkin')?.value || window.localData?.h_checkin)?.replace(/-/g, '/');
        const checkout = (document.querySelector('#s_checkout')?.value || window.localData?.h_checkout)?.replace(/-/g, '/');
        if (dateBeginText && dateEndText && !checkin && !checkout) {
            widgetData.dateBegin = translateDate(dateBeginText, thn.data.language);
            widgetData.dateEnd = translateDate(dateEndText, thn.data.language);
        }
        else {
            widgetData.dateBegin = checkin;
            widgetData.dateEnd = checkout;
        }
        // Guests, Adults & Children
        const adults = (document.querySelector('.v-num-adult') || {}).textContent;
        const children = (document.querySelector('.v-num-child') || {}).textContent;
        if (adults && children) {
            widgetData.adults = thn.parseNumber(adults);
            widgetData.children = thn.parseNumber(children);
            widgetData.guests = widgetData.adults + widgetData.children;
        }
        // Prices & Currency || No Rooms
        const priceSelector = document.querySelectorAll('.js-price-breakdown');
        const prices = [...priceSelector]?.map((elm) => thn.parseNumber(elm.textContent));
        const currency = thn.parseCurrency(priceSelector[0]?.textContent);
        const noRooms = document.querySelector('#no_result');
        if (prices && !noRooms) {
            widgetData.price = Math.min(...prices);
            widgetData.currency = currency;
            widgetData.set = true;
        }
        else {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * Implements **bookingId**.
       *
       * @memberOf module:bs_136
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const dataLayer = window.dataLayer;
        const ec = dataLayer && thn.arrayGet(dataLayer, 'ecommerce');
        const purchase = dataLayer.filter((el) => el?.[0] === 'event' && el?.[1] === 'purchase');
        const finalPurchaseData = purchase?.[purchase.length - 1];
        const priceFromDom = document.querySelector('.optional-information .text-totalbook')?.textContent?.trim();
        const bookingId = ec?.purchase?.actionField?.id || thn.objectGet(finalPurchaseData, 'transaction_id') || document.querySelector('#reservationNumber, .reservation-number, .confirmation-summary__number .text')?.textContent?.trim();
        const price = ec?.purchase?.actionField?.revenue || thn.objectGet(finalPurchaseData, 'value') || thn.parseNumber(priceFromDom);
        const currency = ec?.currencyCode || thn.objectGet(finalPurchaseData, 'currency') || thn.getCurrencyCode(priceFromDom?.match(/[^\d\s,.]+/)?.[0]);
        if (!bookingId) {
            widgetData.set = false;
            return widgetData;
        }
        widgetData.bookingId = bookingId;
        widgetData.price = thn.parseNumber(price);
        widgetData.currency = currency;
        if (window.checkin) {
            widgetData.dateBegin = window.checkin.replace(/-/g, '/');
        }
        else if (window.h_checkin) {
            widgetData.dateBegin = window.h_checkin.replace(/-/g, '/');
        }
        if (window.checkout) {
            widgetData.dateEnd = window.checkout.replace(/-/g, '/');
        }
        else if (window.h_checkout) {
            widgetData.dateEnd = window.h_checkout.replace(/-/g, '/');
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_136
       * @this thn.widgets.price
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        const promocode = document.querySelector('#s_accesscode')?.value;
        if (promocode) {
            ctx.promocode = promocode;
        }
        return ctx.promocode;
    };
    return engine;
}

export { factory };
